import Axios from 'axios';
import appConfig from '../config';

const attachFiles = {
  async update(payload) {
    return await Axios.put(appConfig.api.attachFiles + '/' + payload.get('id'), payload);
  },
};

export default attachFiles;
